var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".75em",
    height: "1em",
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14 19.905a.735.735 0 00.722 0 14.05 14.05 0 007.136-12.411l-.002-.15c-.046-2.263-.883-4.166-2.418-5.508C11.224.652 9.421 0 7.502 0S3.777.652 2.42 1.836C.888 3.176.052 5.08.003 7.343.001 7.445 0 7.546 0 7.65c-.002 5.087 2.73 9.778 7.14 12.256zM3.393 2.963C4.478 2.014 5.937 1.492 7.5 1.492c1.564 0 3.022.522 4.108 1.47 1.21 1.058 1.87 2.584 1.91 4.413a12.597 12.597 0 01-1.76 6.71A12.567 12.567 0 017.5 18.39 12.555 12.555 0 011.48 7.511c.002-.046.002-.09.002-.136.039-1.83.7-3.355 1.91-4.412z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm1.665-1.174A3.069 3.069 0 017.5 4.432v.001a3.069 3.069 0 11-2.835 1.893z",
    fill: "currentColor"
  })));
}

export default SvgMapPin;